// import { useState } from "react";
import { Link } from "react-router-dom";
import ChatWidget from "../components/ChatWidget";
// import HomeBanner from "../components/HomeBanner"; // We've replaced the banner with an editorial hero

import Logo from "../assets/Logo.jpeg"; // Your logo-specific banner
import Img1 from "../assets/image1.jpeg";
//import Img2 from "../assets/image2.jpeg";
import Img3 from "../assets/image3.jpeg";
//import Img4 from "../assets/image4.jpg";
import Img5 from "../assets/image5.jpg";
// import Img6 from "../assets/image6.jpeg";
import Img7 from "../assets/image7.jpeg";
import TheCakeryLogo from "../assets/TheCakery.jpeg";
import DesignedByDeeLogo from "../assets/DesignedByDee.jpeg";
import BakedGoodsLogo from "../assets/BakedGoods.jpeg";
import NVRLogo from "../assets/NVR.png";


export default function Home() {
  return (
    <div className="bg-white min-h-screen overflow-x-hidden">
      
      {/* 🔝 ELEGANT EDITORIAL HERO - Replaces HomeBanner */}
      <section className="relative pt-24 pb-20 lg:pt-5 lg:pb-32 px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-20 lg:gap-28">
          
          {/* Brand & Call to Action */}
          <div className="lg:w-1/2 text-center lg:text-left z-10 order-2 lg:order-1">
            <span className="text-[10px] uppercase tracking-[0.5em] text-pink-400 font-bold mb-4 block">
              Branding & Events Studio
            </span>
            
            <h1 className="font-['Playfair_Display'] text-5xl md:text-6xl lg:text-7xl font-light leading-[1.15] text-gray-900 mb-10">
              Let's Create <br />
              <span className="italic text-neutral-700">Something </span>
                <span className="italic text-pink-500"> Timeless. </span>
            </h1>

            <div className="text-gray-500 text-base md:text-lg font-light leading-[1.8] max-w-xl mx-auto lg:mx-0 mb-14">
              <p className="mb-6">
                A full-service studio specialising in <span className="text-neutral-800 font-normal">personalised branding</span> and seamless event execution for individuals, businesses, and organisations.
              </p>
              
              <p>
                We design experiences that allow our clients to be <span className="text-neutral-800 font-normal italic">fully present</span> while we handle every detail with care and professionalism.
              </p>
            </div>
          </div>

          {/* Featured Visual with Logo */}
          <div className="lg:w-1/2 relative group w-full max-w-lg order-1 lg:order-2">
            <div className="absolute -inset-8 bg-gradient-to-br from-neutral-50 via-pink-50/30 to-teal-50/30 rounded-[3rem] blur-3xl opacity-50 group-hover:opacity-70 transition-opacity duration-700" />
            
            <div className="relative z-10 overflow-hidden rounded-[2.5rem] shadow-xl aspect-[4/5] md:aspect-square lg:aspect-[4/5] bg-neutral-50">
              <img 
                src={Logo} 
                alt="Branding & Events Studio" 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
              />
            </div>
          </div>
        </div>
      </section>



      {/* 💎 Floating Glass Card Detail */}
      {/* <div className="absolute -bottom-8 -right-8 z-20 hidden md:block w-48 p-6 rounded-3xl bg-white/40 backdrop-blur-xl border border-white/40 shadow-2xl transition-transform duration-700 group-hover:-translate-y-4">
        <p className="font-['Playfair_Display'] italic text-lg text-neutral-800">"Be Present."</p>
        <p className="text-[9px] uppercase tracking-[0.2em] text-teal-600 mt-2 font-bold">The Studio Ethos</p>
      </div>
    </div>

  </div> */}


      {/* ✨ INTRO SECTION - Editorial Style */}
      <section className="relative py-24 md:py-32 px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16">

          {/* Text Content */}
    <div className="md:w-1/2 text-left z-10">
      <div className="flex items-center gap-3 mb-6">
        <span className="text-[10px] uppercase tracking-[0.5em] text-red-600 font-bold">
          Est. 2025
        </span>
        <div className="h-[1px] w-8 bg-neutral-200" />
      </div>
      
      <h2 className="font-['Playfair_Display'] text-4xl md:text-6xl font-light text-gray-900 leading-tight mb-8">
        Crafting Brands, <br />
        <span className="italic bg-gradient-to-r from-neutral-800 to-red-600 bg-clip-text text-transparent">
          Planning Memories.
        </span>
      </h2>
      
      <p className="text-gray-500 leading-relaxed text-lg font-light max-w-md border-l border-pink-100 pl-6">
        A full-service branding and events studio specialising in personalised 
        solutions for the visionary individual.
      </p>
    </div>
        
          
        {/* Featured Image Gallery with Uniform Sizing */}
<div className="md:w-1/2 grid grid-cols-2 gap-4 relative h-full">
  
  {/* Left Column */}
  <div className="h-full">
    <img 
      src={Img7} 
      alt="Event Setup" 
      className="w-full h-[450px] object-cover rounded-3xl shadow-2xl hover:scale-105 transition-transform duration-700" 
    />
  </div>

  {/* Right Column */}
  <div className="flex flex-col gap-4 h-full">
    <div className="h-1/2">
      <img 
        src={Img3} 
        alt="Event Detail" 
        className="w-full h-[217px] object-cover rounded-3xl shadow-xl hover:scale-105 transition-transform duration-700" 
      />
    </div>
    <div className="h-1/2">
      <img 
        src={Img5} 
        alt="Branding Display" 
        className="w-full h-[217px] object-cover rounded-3xl shadow-xl translate-x-4 hover:translate-x-0 transition-transform duration-700" 
      />
    </div>
  </div>

</div>
</div>
      </section>

      {/* 🌸 ABOUT SECTION - Immersive Split Layout */}
      <section className="bg-neutral-50 py-24 md:py-32 px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row-reverse items-center gap-20">
          <div className="md:w-1/2 text-center md:text-left">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-normal text-gray-900 mb-6">
              Our Story
            </h2>
            <div className="w-12 h-[2px] bg-green-700 mb-8 mx-auto md:mx-0" />
            <p className="text-green-700 leading-relaxed mb-8 font-light italic text-lg">
              "We Plan. We Brand. You Enjoy."
            </p>
            <div className="text-gray-500 leading-relaxed font-light mb-8">
             
             <p>Branding and Events Studio was founded by a group of females, inspired by the experience of planning a recent wedding that prioritised allowing the bride to be fully present and enjoy the occasion without the burden of logistical concerns. 
            </p>
            <br/>
              <p>Branding and Events Studio is a co-founded enterprise that emerged from a shared vision and officially began on 18 December 2025, uniting diverse skills and passions into a single, purpose-driven business concept.</p>
          </div>

            <Link
              to="/team-biography"
              className="inline-flex items-center rounded-full border border-green-700/40 bg-white/80 px-5 py-2 text-xs font-medium uppercase tracking-[0.2em] text-green-800 transition-all duration-300 hover:border-green-700 hover:bg-green-700 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700/40"
            >
              Learn More About Us
            </Link>
          </div>
          <div className="md:w-1/2 overflow-hidden rounded-[3rem] shadow-2xl">
            <img src={Img1} alt="Studio Team" className="w-full h-full object-cover transition-all duration-1000" />
          </div>
        </div>
      </section>

      {/* 💎 SERVICES SECTION - Modern Glass Cards */}
      <section className="bg-white py-32 px-6 relative border-t border-neutral-100">
        {/* Large Faded Background Text */}
        <div className="absolute top-10 left-0 w-full text-center pointer-events-none opacity-[0.03] select-none">
          <h1 className="text-[15vw] font-['Playfair_Display']">SERVICES</h1>
        </div>

        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl mb-20">Our Services</h2>
          
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
            {services.map((service, index) => (
              <div
                key={index}
                className="group p-10 rounded-[2.5rem] bg-white border border-neutral-100 shadow-sm hover:shadow-2xl transition-all duration-500 text-left hover:-translate-y-2"
              >
                <div className="w-12 h-12 bg-pink-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-pink-500 transition-colors duration-500">
                  <span className="text-pink-500 group-hover:text-white font-bold">{index + 1}</span>
                </div>
                <h3 className="font-['Playfair_Display'] text-xl text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed font-light">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-neutral-50 py-16 border-t border-neutral-100">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-10">
            <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl text-gray-900">Trusted Vendors</h3>
            <p className="text-gray-500 text-sm mt-2">Our preferred partners</p>
          </div>

          <div className="vendor-marquee-wrapper">
            <div className="vendor-marquee-track">
              {[...trustedVendors, ...trustedVendors].map((vendor, index) => (
                <div
                  key={`${vendor.name}-${index}`}
                  className="vendor-logo-pill"
                >
                  <img
                    src={vendor.logo}
                    alt={vendor.name}
                    className="vendor-logo-image"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* <div className="flex justify-center">
      <a
        href="https://zcform.com/cdEgE"
        target="_blank"
        rel="noopener noreferrer"
        className="luxuryButton"
        >
          Download Form
      </a>
      </div> */}


      <ChatWidget />
    </div>
  );
}

const services = [
  { title: "Personalised Branding", description: "Corporate branding, gifting, and tailored design solutions crafted to elevate your identity." },
  { title: "Event Planning & Coordination", description: "Private, corporate, and community events curated with precision and creativity." },
  { title: "Event Logistics Management", description: "Supplier coordination, timelines, and seamless execution from start to finish." },
  // { title: "End-to-End Execution", description: "On-the-day coordination and complete event management for peace of mind." },
  // { title: "Trusted Network", description: "A curated network of reliable partners and premium service providers." }
];

const trustedVendors = [
  { name: "The Cakery", logo: TheCakeryLogo },
  { name: "Designed By Dee", logo: DesignedByDeeLogo },
  { name: "Baked Goods", logo: BakedGoodsLogo },
  { name: "NVR", logo: NVRLogo }
];
